// extracted by mini-css-extract-plugin
export var modal = "VerificationGate-module--modal--739e6";